// App.jsx
import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// The route guard and the shared layout are needed on literally every route, so
// they stay in the main bundle. Everything else is loaded on demand: a visitor
// browsing listings should never download the admin dashboard.
import ProtectedRoute from "./data/ProtectRoute.js";
import Layout from "./Components/layout/layout";

//! --------------------!Website Pages -------------------------------------
const Login = lazy(() => import("./Pages/Login.js"));
const NotFound = lazy(() => import("./Pages/NotFound.js"));
const SignUp = lazy(() => import("./Pages/SignUp.js"));
const ResetPassword = lazy(() => import("./Pages/ResetPassword.js"));
const HomePage = lazy(() => import("./Pages/homepage.js"));
const BuyPage = lazy(() => import("./Pages/buy.js"));
const SellPage = lazy(() => import("./Pages/sell.js"));
const AgentPage = lazy(() => import("./Pages/agent.js"));
const AboutPage = lazy(() => import("./Pages/about.js"));
const ContactPage = lazy(() => import("./Pages/contact.js"));
const PropertyPage = lazy(() => import("./Pages/homeproperty.js"));
const HomeProperty = lazy(() => import("./Pages/realestateproperty.js"));
const AgentProperty = lazy(() => import("./Pages/agentproperty.js"));
const VerifiedPage = lazy(() =>
  import("./Pages/StatusPage.js").then((m) => ({ default: m.VerifiedPage }))
);
const CheckoutSuccessPage = lazy(() =>
  import("./Pages/StatusPage.js").then((m) => ({
    default: m.CheckoutSuccessPage,
  }))
);
const CheckoutCancelPage = lazy(() =>
  import("./Pages/StatusPage.js").then((m) => ({
    default: m.CheckoutCancelPage,
  }))
);

//! --------------------!dashboard Admin -------------------------------------
const DashoboardAdmin = lazy(() => import("./Pages/Dashboard/DashoboardAdmin.js"));
const MainBody = lazy(() => import("./Pages/Dashboard/MainBody.js"));
const UserBody = lazy(() => import("./Pages/Dashboard/UserBody.js"));
const HousesBody = lazy(() => import("./Pages/Dashboard/HousesBody.js"));
const HouseProperty = lazy(() => import("./Pages/Dashboard/HouseProperty.js"));
const RealEstate = lazy(() => import("./Pages/Dashboard/RealEstate.js"));
const RealEstateProperty = lazy(() =>
  import("./Pages/Dashboard/RealEstateProperty.js")
);
const ProfilePage = lazy(() => import("./Pages/Dashboard/ProfilePage.js"));

//! --------------------!dashboard Agent -------------------------------------
const DashoboardAgnet = lazy(() =>
  import("./Pages/Agent_DashBoard/DashoboardAdmin.js")
);
const MainBodyAgent = lazy(() => import("./Pages/Agent_DashBoard/MainBody.js"));
const HousesBodyAgent = lazy(() =>
  import("./Pages/Agent_DashBoard/HousesBody.js")
);
const HousePropertyAgent = lazy(() =>
  import("./Pages/Agent_DashBoard/HouseProperty.js")
);
const RealEstateAgent = lazy(() =>
  import("./Pages/Agent_DashBoard/RealEstate.js")
);
const RealEstatePropertyAgent = lazy(() =>
  import("./Pages/Agent_DashBoard/RealEstateProperty.js")
);
const ProfilePageAgent = lazy(() =>
  import("./Pages/Agent_DashBoard/ProfilePage.js")
);

const RouteFallback = () => (
  <div className="bodyProtect" style={{ padding: "80px 0", textAlign: "center" }}>
    <p>Loading...</p>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Suspense fallback={<RouteFallback />}>
        <Routes>
          {/* ---------------------- public website pages ---------------------- */}
          <Route path="/" element={<HomePage />} />

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route
            path="/reset-password/:userId/:token"
            element={<ResetPassword />}/>

          {/* Landing pages for flows that re-enter the app from elsewhere:
              the email verification link and Stripe's checkout redirect. */}
          <Route path="/verified" element={<VerifiedPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />



          <Route path="*" element={<NotFound />} />

          <Route path="/buy" element={<BuyPage />} />
          <Route path="/sell" element={<SellPage />} />
          <Route path="/agent" element={<AgentPage />} />
          <Route path="/about" element={<AboutPage />} />

          <Route path="/contact" element={<ContactPage />} />
          {/* property page for home properties */}
          <Route path="/properties/:propertyId" element={<PropertyPage />} />

          {/* property page for real estates properties */}
          <Route path="/realestateproperty/:id" element={<HomeProperty />} />

          {/* property page for agents properties */}
          <Route path="/agents/:agentId" element={<AgentProperty />} />

          {/* ---------------------- admin dashboard ---------------------- */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <DashoboardAdmin />
              </ProtectedRoute>
            }
          >
            <Route path="profilePage" element={<ProfilePage />} />
            <Route path="mainBody" element={<MainBody />} />
            <Route path="userBody" element={<UserBody />} />
            <Route path="housesBody" element={<HousesBody />} />{" "}
            <Route path="house/:id" element={<HouseProperty />} />
            <Route path="realEstate" element={<RealEstate />} />
            <Route path="realEstate/:id" element={<RealEstateProperty />} />
          </Route>

          {/* ---------------------- agent dashboard ---------------------- */}
          <Route
            path="/dashboardAgent"
            element={
              <ProtectedRoute allowedRoles={["agent"]}>
                <DashoboardAgnet />
              </ProtectedRoute>
            }
          >
            <Route path="ProfilePageAgent" element={<ProfilePageAgent />} />
            <Route path="MainBodyAgent" element={<MainBodyAgent />} />
            <Route path="HousesBodyAgent" element={<HousesBodyAgent />} />{" "}
            <Route
              path="HousePropertyAgent/:id"
              element={<HousePropertyAgent />}
            />
            <Route path="RealEstateAgent" element={<RealEstateAgent />} />
            <Route
              path="RealEstatePropertyAgent/:id"
              element={<RealEstatePropertyAgent />}
            />
          </Route>
        </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
